import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackBookingComponent } from '../modals/track-booking/track-booking.component';
import { TrackErrorComponent } from '../modals/tracking-error-modal/tracking-error-modal.component';
import { FrontierForceTrackBookingComponent } from '../modals/frontier-force-track-booking/frontier-force-track-booking.component';

@Injectable({
  providedIn: 'root'
})

export class ModalService {

  constructor(private modalService: NgbModal) {}

  openModal(modalContent: any): void {
    this.modalService.open(modalContent,{ animation: true, size: 'lg' });
  }

  openTrackBookingModal(data: any): void {
    let trackBookingModal = this.modalService.open(TrackBookingComponent, { animation:true,size: 'lg', centered: true, backdrop: 'static', keyboard: false});
    trackBookingModal.componentInstance.trackNo = data;
  }

  openFrontierForceTrackBookingModal(data: any): void {
    let trackBookingModal = this.modalService.open(FrontierForceTrackBookingComponent, { animation:true,size: 'lg', centered: true, backdrop: 'static', keyboard: false});
    trackBookingModal.componentInstance.trackNo = data;
  }

  openTrackErrorModal(): void {
    let trackErrorModal = this.modalService.open(TrackErrorComponent, { animation: true, size: 'lg', centered: true, backdrop: 'static', keyboard: false});
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }

  openQuoteModal(modalContent:any){
   return this.modalService.open(modalContent,{ animation:true,size:'lg'});
  }

}
